var _rect, _rect2, _path, _path2, _path3, _path4, _mask, _ellipse, _path5, _mask2, _ellipse2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.864258,
    y: 2.354,
    width: 12.271,
    height: 14.3127,
    rx: 0.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.94775,
    y: 1.3335,
    width: 4.10424,
    height: 1.0417,
    rx: 0.5,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26514 7.05591C6.98899 7.05591 6.76514 7.27977 6.76514 7.55591C6.76514 7.83205 6.98899 8.05591 7.26514 8.05591V7.05591ZM10.5791 8.05591C10.8552 8.05591 11.0791 7.83205 11.0791 7.55591C11.0791 7.27977 10.8552 7.05591 10.5791 7.05591V8.05591ZM7.26514 8.05591H10.5791V7.05591H7.26514V8.05591Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32275 9.60815C6.04661 9.60815 5.82275 9.83201 5.82275 10.1082C5.82275 10.3843 6.04661 10.6082 6.32275 10.6082L6.32275 9.60815ZM10.579 10.6082C10.8551 10.6082 11.079 10.3843 11.079 10.1082C11.079 9.83201 10.8551 9.60815 10.579 9.60815L10.579 10.6082ZM6.32275 10.6082L10.579 10.6082L10.579 9.60815L6.32275 9.60815L6.32275 10.6082Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32275 12.2419C6.04661 12.2419 5.82275 12.4658 5.82275 12.7419C5.82275 13.0181 6.04661 13.2419 6.32275 13.2419L6.32275 12.2419ZM10.5788 13.2419C10.8549 13.2419 11.0788 13.0181 11.0788 12.7419C11.0788 12.4658 10.8549 12.2419 10.5788 12.2419L10.5788 13.2419ZM6.32275 13.2419L10.5788 13.2419L10.5788 12.2419L6.32275 12.2419L6.32275 13.2419Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41943 6.53501L4.29886 7.41443C4.37696 7.49254 4.5036 7.49254 4.5817 7.41443L6.48198 5.51416",
    stroke: "white",
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_452_27795",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.44044,
    cy: 9.91969,
    rx: 0.765636,
    ry: 0.765635
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.44044,
    cy: 9.91969,
    rx: 0.765636,
    ry: 0.765635,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20608 9.91969C4.20608 9.79025 4.311 9.68532 4.44044 9.68532V11.6853C5.41557 11.6853 6.20608 10.8948 6.20608 9.91969H4.20608ZM4.44044 9.68532C4.56988 9.68532 4.6748 9.79025 4.6748 9.91969H2.6748C2.6748 10.8948 3.46531 11.6853 4.44044 11.6853V9.68532ZM4.6748 9.91969C4.6748 10.0491 4.56988 10.1541 4.44044 10.1541V8.15405C3.46531 8.15405 2.6748 8.94455 2.6748 9.91969H4.6748ZM4.44044 10.1541C4.311 10.1541 4.20608 10.0491 4.20608 9.91969H6.20608C6.20608 8.94455 5.41557 8.15405 4.44044 8.15405V10.1541Z",
    fill: "white",
    mask: "url(#path-7-inside-1_452_27795)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_452_27795",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.44044,
    cy: 12.7417,
    rx: 0.765636,
    ry: 0.765635
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.44044,
    cy: 12.7417,
    rx: 0.765636,
    ry: 0.765635,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20608 12.7417C4.20608 12.6123 4.311 12.5073 4.44044 12.5073V14.5073C5.41557 14.5073 6.20608 13.7168 6.20608 12.7417H4.20608ZM4.44044 12.5073C4.56988 12.5073 4.6748 12.6123 4.6748 12.7417H2.6748C2.6748 13.7168 3.46531 14.5073 4.44044 14.5073V12.5073ZM4.6748 12.7417C4.6748 12.8711 4.56988 12.9761 4.44044 12.9761V10.9761C3.46531 10.9761 2.6748 11.7666 2.6748 12.7417H4.6748ZM4.44044 12.9761C4.311 12.9761 4.20608 12.8711 4.20608 12.7417H6.20608C6.20608 11.7666 5.41557 10.9761 4.44044 10.9761V12.9761Z",
    fill: "white",
    mask: "url(#path-9-inside-2_452_27795)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadGeneration);
export default __webpack_public_path__ + "static/media/lead-generation.0ad2316c5adba9883f094bf46c6534bf.svg";
export { ForwardRef as ReactComponent };